import { TYPE_AVERAGE, TYPE_SUM } from "@/helpers/constants";
import { configNumberFormatter, formatters } from "@/helpers/formatters";
import { PlanInputDictionary } from "@/types/common";
export default <PlanInputDictionary[]>[
  // lvl 0
  {
    title: "Business Goal",
    value: "business_goal",
    tableGroup: "dimension",
    lvl: 0,
    formatter: formatters.stringFormat,
  },
  {
    title: "Campaign ID",
    value: "campaign_id",
    tableGroup: "dimension",
    lvl: 0,
    formatter: formatters.stringFormat,
  },

  // lvl 1
  {
    title: "Plan",
    value: "plan",
    tableGroup: "dimension",
    lvl: 1,
    persistent: true,
    formatter: formatters.stringFormat,
  },
  {
    title: "Geography",
    value: "geography",
    tableGroup: "dimension",
    lvl: 1,
    formatter: formatters.firstOrAllStates,
  },

  // lvl 2 - Dimensions
  {
    title: "Channel",
    value: "channel",
    tableGroup: "dimension",
    lvl: 2,
    persistent: true,
    formatter: formatters.stringFormat,
  },
  {
    title: "Campaign KPI",
    value: "campaign_kpi",
    tableGroup: "dimension",
    lvl: 2,
    formatter: formatters.stringFormat,
  },
  {
    title: "Start Date",
    value: "start_date",
    tableGroup: "dimension",
    lvl: 2,
    formatter: formatters.formatDate,
    editable: true,
  },
  {
    title: "End Date",
    value: "end_date",
    tableGroup: "dimension",
    lvl: 2,
    formatter: formatters.formatDate,
    editable: true,
  },

  // lvl 2 - Standard Metrics
  {
    title: "% of Budget",
    value: "channel_percentage",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.compactPercentFormat,
    type: TYPE_SUM,
    editable: true,
  },
  {
    title: "Budget",
    value: "budget",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.formattedCurrencyNoFraction,
    type: TYPE_SUM,
    editable: true,
  },
  {
    title: "CPM",
    value: "cpm",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Impression",
  },
  {
    title: "Impressions",
    value: "impressions",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
  },
  {
    title: "Acquisitions",
    value: "acquisitions",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
  },
  {
    title: "App Events",
    value: "app_events",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
  },
  {
    title: "App Installs",
    value: "app_installs",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
  },
  {
    title: "Event Response",
    value: "event_response",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
  },
  {
    title: "Local Action",
    value: "local_action",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
  },

  {
    title: "Bookings",
    value: "bookings",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
  },
  {
    title: "Clicks",
    value: "clicks",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
  },
  {
    title: "Completed Views",
    value: "completed_views",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
  },
  {
    title: "Engagements",
    value: "engagements",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
  },
  {
    title: "Intent Actions",
    value: "intent_actions",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
  },
  {
    title: "Landing Page Visits",
    value: "landing_page_views",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
  },
  {
    title: "Leads",
    value: "leads",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
  },
  {
    title: "Link Clicks",
    value: "link_clicks",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
  },
  {
    title: "Page Likes",
    value: "page_likes",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
  },
  {
    title: "Purchase Value",
    value: "purchase_value",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.formattedCurrencyNoFraction,
    type: TYPE_SUM,
  },
  {
    title: "Purchases",
    value: "purchases",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
  },
  {
    title: "Site Action",
    value: "site_action",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
  },
  {
    title: "Submissions/Entries",
    value: "submission_entries",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
  },
  {
    title: "Store Visits",
    value: "store_visits",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
  },
  {
    title: "Video Views",
    value: "video_views",
    tableGroup: "standard",
    lvl: 2,
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
  },

  // lvl 2 - Countable Metrics (Calculated)
  {
    title: "CPB",
    value: "cpb",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Booking",
  },
  {
    title: "CPC",
    value: "cpc",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
  },
  {
    title: "CPCV",
    value: "cpcv",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Video View",
  },
  {
    title: "CPE",
    value: "cpe",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Engagement",
  },
  {
    title: "CPER",
    value: "cper",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Event Response",
  },
  {
    title: "CPA",
    value: "cpa",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Acquisition",
  },
  {
    title: "CPAE",
    value: "cpae",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "App Event",
  },
  {
    title: "CPI",
    value: "cpi",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "App Install",
  },
  {
    title: "CPIA",
    value: "cpia",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Intent Action",
  },
  {
    title: "CPL",
    value: "cpl",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Lead Gen",
  },
  {
    title: "CPLA",
    value: "cpla",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Local Action",
  },
  {
    title: "CPLC",
    value: "cplc",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Link Click",
  },
  {
    title: "CPLV",
    value: "cplv",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Landing Page Visit",
  },
  {
    title: "CPP",
    value: "cpp",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Purchase",
  },
  {
    title: "CPPL",
    value: "cppl",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Page Like",
  },
  {
    title: "CPS",
    value: "cps",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Submission / Entry",
  },
  {
    title: "CPSA",
    value: "cpsa",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Website Action",
  },
  {
    title: "CPSV",
    value: "cpsv",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "Store Visit",
  },
  {
    title: "CTR",
    value: "ctr",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.percentFormat,
    configFormatter: configNumberFormatter.percentFormat,
    type: TYPE_AVERAGE,
    editable: true,
  },
  {
    title: "ROAS",
    value: "roas",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.numberTwoDecimals,
    type: TYPE_AVERAGE,
    editable: true,
    kpiTrigger: "ROAS",
  },
  {
    title: "VCR",
    value: "vcr",
    tableGroup: "calculated",
    lvl: 2,
    formatter: formatters.percentFormat,
    configFormatter: configNumberFormatter.percentFormat,
    type: TYPE_AVERAGE,
    editable: true,
  },
];
